import React, { useState } from "react";
import { formatNumber } from "../../Helper/Helper";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import arr from "../../img/arrow-down.png";
import "./Table.scss";

export default function Table({
  date2,
  date1,
  firstThName,
  tableTitle,
  data,
  showBtn,
  revert,
  openModal,
  noAhead,
  Ahead,
  type,
}) {
  // hide ahead row
  if (noAhead) {
    const newData = data
      .filter((item) => item)
      .filter((item) => item.col1 !== "Day-Ahead");
    data = newData;
  }
  if (Ahead) {
    const newData = data
      .filter((item) => item)
      .filter((item) => item.col1 === "Day-Ahead");
    data = newData;
  }

  const [expand, setExpand] = useState(false);

  const element = <FontAwesomeIcon icon={faExternalLink} />;

  const formatDateHead = (num) => {
    const d = new Date(num);
    // let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    const mo = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(d);
    const newDate = `${da} ${mo}`;

    return newDate;
  };

  return (
    <div className="NbpPricesTable">
      <h3
        className={
          tableTitle === "none" ? "text-center displayNone" : "text-center"
        }
      >
        {tableTitle}
      </h3>

      <div
        className={
          showBtn === "none"
            ? "table-container table-full-size"
            : expand === false
            ? "table-container table-half-size"
            : "table-container table-full-size"
        }
      >
        <table className="total-table total-table-stripped table-sm">
          <thead>
            <tr>
              <th className={Ahead && "singl"}>{firstThName}</th>
              <th>{formatDateHead(date1)}</th>
              <th>{formatDateHead(date2)}</th>
              <th>Daily % </th>
              <th>Weekly %</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((row, index) => {
              return (
                <tr key={index}>
                  {revert ? (
                    <>
                      {row.col1 === "Day-Ahead" ? (
                        <td className="Ahead" onClick={openModal}>
                          <button className="btn external">
                            {row.col1} &nbsp; {element}
                          </button>
                        </td>
                      ) : (
                        <td>{row.col1}</td>
                      )}

                      <td>{formatNumber(row.col2)}</td>
                      <td>{formatNumber(row.col3)}</td>
                      <td
                        style={{ color: `${row.col4 < 0 ? "green" : "red"}` }}
                      >
                        {formatNumber(row.col4)}%
                      </td>
                      <td
                        style={{ color: `${row.col5 < 0 ? "green" : "red"}` }}
                      >
                        {formatNumber(row.col5)}
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{formatNumber(row.col1)}</td>
                      <td>{formatNumber(row.col2)}</td>
                      <td>{formatNumber(row.col3)}</td>
                      <td
                        style={{ color: `${row.col4 < 0 ? "green" : "red"}` }}
                      >
                        {formatNumber(row.col4)}%
                      </td>
                      <td
                        style={{ color: `${row.col5 < 0 ? "green" : "red"}` }}
                      >
                        {formatNumber(row.col5)}%
                      </td>
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
        {type === "Hourly" && (
          <p className="tablenote">*Note: Published Data is on Trading Day</p>
        )}
      </div>
      <div
        className={
          showBtn === "none"
            ? "exp-btn text-end displayNone"
            : "exp-btn text-end"
        }
      >
        <button
          onClick={() => setExpand(!expand)}
          type="button"
          className="expand btn"
        >
          Expand&nbsp;
          <img src={arr} alt="expand" />
        </button>
      </div>
    </div>
  );
}
